module.exports = __webpack_public_path__ + "static/media/whyjapan.52b64480.png";